module.exports = __webpack_public_path__ + "img/icon-certif.1a566977.svg";